import { ChangeEvent, createRef, FC, ReactNode, useEffect, useState } from 'react';
import classNames from 'classnames';
import { createPortal } from 'react-dom';

import './modal.scss';

export interface IModal {
  onClickOutside(event: ChangeEvent): void;
  isClickOutsideDisabled?: boolean;
  onEsc(event: HTMLButtonElement): void;
  children: ReactNode;
  withOverlay: boolean;
  className?: string;
}

const Modal: FC<IModal> = ({
  onClickOutside,
  onEsc,
  children,
  withOverlay,
  isClickOutsideDisabled,
  className,
}) => {
  const [containerElement] = useState(document.createElement('div'));

  const modalRef = createRef<HTMLDivElement>();

  const handleClick = (event: ChangeEvent<any>) => {
    if (event.target === modalRef.current && !isClickOutsideDisabled) {
      onClickOutside(event);
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.keyCode === 27 || event.target?.keyCode === 27) {
      onEsc(event);
    }
  };
  useEffect(() => {
    const { body } = document;
    body.appendChild(containerElement);
    body.addEventListener('keydown', handleKeyDown);

    return () => {
      body.removeChild(containerElement);
      body.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return createPortal(
    <div
      ref={modalRef}
      onClick={handleClick}
      className={classNames('modal-container', { overlay: withOverlay }, [className])}
    >
      {children}
    </div>,
    containerElement,
  );
};

export default Modal;
